
const qntSelectors = (function(){
  var _this = {
    init:function(){
      $(document).on('click','.js-qty-selector span',function(){
        const input = $(this).closest('.js-qty-selector').find('input')
        const math = $(this).attr('data-math')
        _this.update(input,math)
      })
    },
    update:function(input,math){
      const a = parseInt(input.val()),
            p1 = a + 1,
            m1 = a - 1,
            min = input.attr('min') || 0,
            max = input.attr('max') || Infinity
                 
      if(math == 'plus' && p1 <= max){
        input.val(p1).trigger('change')
      }
      if(math == 'minus' && m1 >= min){
        input.val(m1).trigger('change')
      }
    },
  }
  return _this
})()


